import { MOCK_STORE_ID_1 } from './seed'

/**
 * Simple leave-day fixtures (distinct from absences.ts). Cross-references
 * seed.ts employees/stores. Shape mirrors `Leave` from
 * `src/services/api/leaves.ts` (kept local to avoid a fixture -> service ->
 * handler -> fixture import cycle).
 */

export interface LeaveFixture {
  startAt: string
  endAt: string
  employeeID: string
  storeID: string
  createdAt: string
  updatedAt: string
}

export const mockLeaves: LeaveFixture[] = [
  {
    employeeID: 'employee-2',
    storeID: MOCK_STORE_ID_1,
    startAt: '2025-07-07',
    endAt: '2025-07-11',
    createdAt: '2025-06-15T08:00:00Z',
    updatedAt: '2025-06-15T08:00:00Z',
  },
  {
    employeeID: 'employee-4',
    storeID: MOCK_STORE_ID_1,
    startAt: '2025-08-04',
    endAt: '2025-08-08',
    createdAt: '2025-06-20T08:00:00Z',
    updatedAt: '2025-06-20T08:00:00Z',
  },
]
